import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Movement } from '../models/movement.entity';
import { MovementsService } from '../services/movements.service';

/**
 * Movements data source
 */
export class MovementDataSource implements DataSource<Movement> {
  /**
   * Work orders subject
   *
   * @private
   */
  private movementsSubject = new BehaviorSubject<Movement[]>([]);

  /**
   * Loading subject
   *
   * @private
   */
  private loadingSubject = new BehaviorSubject<boolean>(false);

  /**
   * Loading observable
   */
  public loading$ = this.loadingSubject.asObservable();

  /**
   * Constructor
   *
   * @param movementsService Movements service
   */
  constructor(private movementsService: MovementsService) {}

  /**
   * Connect to collection
   *
   * @returns Observable
   */
  connect(): Observable<Movement[]> {
    return this.movementsSubject.asObservable();
  }

  /**
   * Disconnect from collection
   */
  disconnect(): void {
    this.movementsSubject.complete();
    this.loadingSubject.complete();
  }

  /**
   * Load data from collection
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Object with filtered attributes
   */
  load(order: string = 'movementId', sort: string = 'desc', limit: number = 10, page: number = 0, filter: object = {}): void {
    this.loadingSubject.next(true);

    const options = { order, sort, limit, page };

    for (const i in filter) {
      if (filter.hasOwnProperty(i) && filter[i] === '') {
        delete filter[i];
      }
    }

    this.movementsService
      .findFiltered({ ...options, ...filter })
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((movements) => {
        this.movementsSubject.next(movements);
      });
  }
}
